(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vac-editorial-ui.i18n-p1-backup"] && !Shopify.designMode) return;
  try {
    const vacReady = new Set();
function vacShowSizePrompt(root){
  const input=root.querySelector('input[data-option-name="Talla"][data-option-available="true"],input[data-option-name="Size"][data-option-available="true"]');
  const group=input?.closest('fieldset');
  const notice=root.querySelector('.vac-size-error');
  if(notice)notice.hidden=false;
  if(group){group.classList.add('vac-size-required');group.setAttribute('aria-invalid','true');group.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  input?.focus({preventScroll:true});
}
function vacKeepSingleSizeSelected(root, picker = root.querySelector('variant-picker')){
  if(!picker)return false;
  const sizes=picker.querySelectorAll('input[data-option-name="Talla"],input[data-option-name="Size"]');
  if(sizes.length!==1)return false;
  const input=sizes[0];
  input.checked=true;
  input.dataset.currentChecked='true';
  input.dataset.previousChecked='false';
  root.classList.remove('vac-needs-size');
  root.dataset.vacSizeInit=picker.dataset.productId+':single';
  root.querySelectorAll('.vac-size-error').forEach(notice=>notice.hidden=true);
  root.querySelectorAll('.vac-size-required').forEach(group=>{group.classList.remove('vac-size-required');group.removeAttribute('aria-invalid');});
  return true;
}
function vacSizeSelected(input){
  if(!input.checked||!['Talla','Size'].includes(input.dataset.optionName)||input.dataset.optionAvailable==='false')return;
  const root=input.closest('product-component');
  if(!root)return;
  root.classList.remove('vac-needs-size');
  vacReady.add(root.querySelector('variant-picker')?.dataset.productId);
  root.querySelectorAll('.vac-size-error').forEach(notice=>notice.hidden=true);
  root.querySelectorAll('.vac-size-required').forEach(group=>{group.classList.remove('vac-size-required');group.removeAttribute('aria-invalid');});
}
function vacInitialize(){
  document.querySelectorAll('[data-vac-toolbar]').forEach(toolbar=>{
    if(toolbar.dataset.vacInit)return;toolbar.dataset.vacInit='true';
    const root=toolbar.closest('results-list');const cards=[...root.querySelectorAll('.product-grid__item[data-vac-category]')];
    const count=toolbar.querySelector('[data-vac-results]');const label=count.textContent.replace(/\d+/, '{count}');
    toolbar.querySelectorAll('[data-vac-category]').forEach(button=>button.addEventListener('click',()=>{const category=button.dataset.vacCategory;const url=new URL(location.href);if(category==='all')url.searchParams.delete('vac_type');else url.searchParams.set('vac_type',category);history.replaceState(null,'',url);let visible=0;cards.forEach(card=>{card.hidden=category!=='all'&&card.dataset.vacCategory!==category;if(!card.hidden)visible++;});toolbar.querySelectorAll('[data-vac-category]').forEach(b=>{b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});count.textContent=label.replace('{count}',visible);}));
    count.textContent=label.replace('{count}',cards.length);
    const requestedCategory=new URLSearchParams(location.search).get('vac_type');if(requestedCategory){const selected=[...toolbar.querySelectorAll('[data-vac-category]')].find(button=>button.dataset.vacCategory===requestedCategory);selected?.click();}
    toolbar.querySelector('[data-vac-sort]').addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');location.assign(url);});
  });
  document.querySelectorAll('cart-icon').forEach(icon=>{
    if(icon.dataset.vacCountInit)return;icon.dataset.vacCountInit='true';
    const sync=()=>{const count=icon.querySelector('.cart-bubble__text-count')?.textContent.trim()||'0';const target=icon.querySelector('.vac-count-number');if(target&&target.textContent!==count)target.textContent=count;};
    new MutationObserver(sync).observe(icon,{childList:true,subtree:true,characterData:true});sync();
  });
  document.querySelectorAll('product-component:has(.product-details)').forEach(root=>{
    const picker=root.querySelector('variant-picker');if(!picker)return;
    const size=picker.querySelector('input[data-option-name="Talla"],input[data-option-name="Size"]');
    if(!size||!root.querySelector('.buy-buttons-block'))return;
    if(vacKeepSingleSizeSelected(root,picker))return;
    const id=picker.dataset.productId;
    const initialized=root.dataset.vacSizeInit;
    if(initialized===id)return;root.dataset.vacSizeInit=id;
    const needsSize=!vacReady.has(id)&&!(root.closest('.product-information')&&new URLSearchParams(location.search).has('variant'));
    root.classList.toggle('vac-needs-size',needsSize);
    if(needsSize){picker.querySelectorAll('input[data-option-name="Talla"],input[data-option-name="Size"]').forEach(input=>{input.checked=false;input.dataset.currentChecked='false';});}
    const bar=root.querySelector('.product-form-buttons, .buy-buttons-block__bar');
    if(bar&&!bar.querySelector('.vac-size-error')){const notice=document.createElement('p');notice.className='vac-size-error';notice.hidden=true;notice.setAttribute('role','alert');notice.textContent=document.getElementById('vac-ui-text')?.dataset.selectSize||'';bar.append(notice);}
  });
  document.querySelectorAll('media-gallery slideshow-component').forEach(slideshow=>{
    if(slideshow.dataset.vacCounter)return;slideshow.dataset.vacCounter='true';
    const count=slideshow.querySelectorAll('slideshow-slide').length;if(count<2)return;
    const arrows=slideshow.querySelector('slideshow-arrows');if(!arrows)return;
    const label=document.createElement('span');label.className='vac-gallery-counter';label.textContent=`1 / ${count}`;label.setAttribute('aria-live','polite');arrows.parentElement.append(label);
    slideshow.addEventListener('slideshow:select',event=>{label.textContent=`${event.detail.index+1} / ${count}`;});
  });
  document.querySelectorAll('.vac-desktop-nav a').forEach(link=>{if(link.pathname===location.pathname&&link.search===location.search)link.setAttribute('aria-current','page');});
}
document.addEventListener('click',event=>{
  const add=event.target.closest('.add-to-cart-button');
  const needsSize=add?.closest('.vac-needs-size');
  if(needsSize&&!vacKeepSingleSizeSelected(needsSize)){event.preventDefault();event.stopImmediatePropagation();vacShowSizePrompt(needsSize);return;}
  const trigger=event.target.closest('[data-vac-guide]');
  if(trigger){event.preventDefault();const root=trigger.closest('product-component');const dialog=trigger.dataset.vacGuide?document.getElementById(trigger.dataset.vacGuide):root?.querySelector('.vac-guide-dialog');if(dialog){dialog.showModal();document.documentElement.style.overflow='hidden';dialog.addEventListener('close',()=>{document.documentElement.style.overflow='';trigger.focus();},{once:true});}}
  if(event.target.closest('[data-vac-close]'))event.target.closest('dialog')?.close();
  if(event.target.matches('.vac-guide-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}
},true);
document.addEventListener('change',event=>{if(event.target.matches('input[data-option-name]'))vacSizeSelected(event.target);},true);
document.addEventListener('submit',event=>{const root=event.target.closest('.vac-needs-size');if(root&&event.target.matches('[data-type="add-to-cart-form"]')&&!vacKeepSingleSizeSelected(root)){event.preventDefault();event.stopImmediatePropagation();vacShowSizePrompt(root);}},true);
let vacPending=false;
new MutationObserver(records=>{if(vacPending||!records.some(r=>r.addedNodes.length))return;vacPending=true;requestAnimationFrame(()=>{vacPending=false;vacInitialize();});}).observe(document.body,{subtree:true,childList:true});
vacInitialize();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vac-editorial-ui"] && !Shopify.designMode) return;
  try {
    const vacReady = new Set();
function vacShowSizePrompt(root){
  const input=root.querySelector('input[data-vac-option-role="size"][data-option-available="true"]');
  const group=input?.closest('fieldset');
  const notice=root.querySelector('.vac-size-error');
  if(notice)notice.hidden=false;
  if(group){group.classList.add('vac-size-required');group.setAttribute('aria-invalid','true');group.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  input?.focus({preventScroll:true});
}
function vacKeepSingleSizeSelected(root, picker = root.querySelector('variant-picker')){
  if(!picker)return false;
  const sizes=picker.querySelectorAll('input[data-vac-option-role="size"]');
  if(sizes.length!==1)return false;
  const input=sizes[0];
  input.checked=true;
  input.dataset.currentChecked='true';
  input.dataset.previousChecked='false';
  root.classList.remove('vac-needs-size');
  root.dataset.vacSizeInit=picker.dataset.productId+':single';
  root.querySelectorAll('.vac-size-error').forEach(notice=>notice.hidden=true);
  root.querySelectorAll('.vac-size-required').forEach(group=>{group.classList.remove('vac-size-required');group.removeAttribute('aria-invalid');});
  return true;
}
function vacSizeSelected(input){
  if(!input.checked||input.dataset.vacOptionRole!=='size'||input.dataset.optionAvailable==='false')return;
  const root=input.closest('product-component');
  if(!root)return;
  root.classList.remove('vac-needs-size');
  vacReady.add(root.querySelector('variant-picker')?.dataset.productId);
  root.querySelectorAll('.vac-size-error').forEach(notice=>notice.hidden=true);
  root.querySelectorAll('.vac-size-required').forEach(group=>{group.classList.remove('vac-size-required');group.removeAttribute('aria-invalid');});
}
function vacInitialize(){
  document.querySelectorAll('[data-vac-toolbar]').forEach(toolbar=>{
    if(toolbar.dataset.vacInit)return;toolbar.dataset.vacInit='true';
    const root=toolbar.closest('results-list');const cards=[...root.querySelectorAll('.product-grid__item[data-vac-category]')];
    const count=toolbar.querySelector('[data-vac-results]');const label=count.textContent.replace(/\d+/, '{count}');
    toolbar.querySelectorAll('[data-vac-category]').forEach(button=>button.addEventListener('click',()=>{const category=button.dataset.vacCategory;const url=new URL(location.href);if(category==='all')url.searchParams.delete('vac_type');else url.searchParams.set('vac_type',category);history.replaceState(null,'',url);let visible=0;cards.forEach(card=>{card.hidden=category!=='all'&&card.dataset.vacCategory!==category;if(!card.hidden)visible++;});toolbar.querySelectorAll('[data-vac-category]').forEach(b=>{b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});count.textContent=label.replace('{count}',visible);}));
    count.textContent=label.replace('{count}',cards.length);
    const requestedCategory=new URLSearchParams(location.search).get('vac_type');if(requestedCategory){const selected=[...toolbar.querySelectorAll('[data-vac-category]')].find(button=>button.dataset.vacCategory===requestedCategory);selected?.click();}
    toolbar.querySelector('[data-vac-sort]').addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');location.assign(url);});
  });
  document.querySelectorAll('cart-icon').forEach(icon=>{
    if(icon.dataset.vacCountInit)return;icon.dataset.vacCountInit='true';
    const sync=()=>{const count=icon.querySelector('.cart-bubble__text-count')?.textContent.trim()||'0';const target=icon.querySelector('.vac-count-number');if(target&&target.textContent!==count)target.textContent=count;};
    new MutationObserver(sync).observe(icon,{childList:true,subtree:true,characterData:true});sync();
  });
  document.querySelectorAll('product-component:has(.product-details)').forEach(root=>{
    const picker=root.querySelector('variant-picker');if(!picker)return;
    const size=picker.querySelector('input[data-vac-option-role="size"]');
    if(!size||!root.querySelector('.buy-buttons-block'))return;
    if(vacKeepSingleSizeSelected(root,picker))return;
    const id=picker.dataset.productId;
    const initialized=root.dataset.vacSizeInit;
    if(initialized===id)return;root.dataset.vacSizeInit=id;
    const needsSize=!vacReady.has(id)&&!(root.closest('.product-information')&&new URLSearchParams(location.search).has('variant'));
    root.classList.toggle('vac-needs-size',needsSize);
    if(needsSize){picker.querySelectorAll('input[data-vac-option-role="size"]').forEach(input=>{input.checked=false;input.dataset.currentChecked='false';});}
    const bar=root.querySelector('.product-form-buttons, .buy-buttons-block__bar');
    if(bar&&!bar.querySelector('.vac-size-error')){const notice=document.createElement('p');notice.className='vac-size-error';notice.hidden=true;notice.setAttribute('role','alert');notice.textContent=document.getElementById('vac-ui-text')?.dataset.selectSize||'';bar.append(notice);}
  });
  document.querySelectorAll('media-gallery slideshow-component').forEach(slideshow=>{
    if(slideshow.dataset.vacCounter)return;slideshow.dataset.vacCounter='true';
    const count=slideshow.querySelectorAll('slideshow-slide').length;if(count<2)return;
    const arrows=slideshow.querySelector('slideshow-arrows');if(!arrows)return;
    const label=document.createElement('span');label.className='vac-gallery-counter';label.textContent=`1 / ${count}`;label.setAttribute('aria-live','polite');arrows.parentElement.append(label);
    slideshow.addEventListener('slideshow:select',event=>{label.textContent=`${event.detail.index+1} / ${count}`;});
  });
  document.querySelectorAll('.vac-desktop-nav a').forEach(link=>{if(link.pathname===location.pathname&&link.search===location.search)link.setAttribute('aria-current','page');});
}
document.addEventListener('click',event=>{
  const add=event.target.closest('.add-to-cart-button');
  const needsSize=add?.closest('.vac-needs-size');
  if(needsSize&&!vacKeepSingleSizeSelected(needsSize)){event.preventDefault();event.stopImmediatePropagation();vacShowSizePrompt(needsSize);return;}
  const trigger=event.target.closest('[data-vac-guide]');
  if(trigger){event.preventDefault();const root=trigger.closest('product-component');const dialog=trigger.dataset.vacGuide?document.getElementById(trigger.dataset.vacGuide):root?.querySelector('.vac-guide-dialog');if(dialog){dialog.showModal();document.documentElement.style.overflow='hidden';dialog.addEventListener('close',()=>{document.documentElement.style.overflow='';trigger.focus();},{once:true});}}
  if(event.target.closest('[data-vac-close]'))event.target.closest('dialog')?.close();
  if(event.target.matches('.vac-guide-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}
},true);
document.addEventListener('change',event=>{if(event.target.matches('input[data-vac-option-role="size"]'))vacSizeSelected(event.target);},true);
document.addEventListener('submit',event=>{const root=event.target.closest('.vac-needs-size');if(root&&event.target.matches('[data-type="add-to-cart-form"]')&&!vacKeepSingleSizeSelected(root)){event.preventDefault();event.stopImmediatePropagation();vacShowSizePrompt(root);}},true);
function vacKlarnaLocaleFallback(){
  const lang=(document.documentElement.lang||'').toLowerCase();
  const base=lang.split('-')[0];
  const localeMap={
    es:'es-ES',
    en:'en-ES',
    gl:'es-ES',
    ca:'es-ES',
    eu:'es-ES',
    ast:'es-ES',
    an:'es-ES',
    oc:'es-ES'
  };
  const targetLocale=localeMap[base];
  if(!targetLocale||document.getElementById('vac-app-i18n')?.dataset.country!=='ES')return;
  let changed=false;
  document.querySelectorAll('klarna-placement').forEach(placement=>{
    if(placement.getAttribute('data-locale')!==targetLocale){
      placement.setAttribute('data-locale',targetLocale);
      changed=true;
    }
  });
  if(changed){
    if(typeof window.Klarna?.OnsiteMessaging?.refresh==='function'){
      window.Klarna.OnsiteMessaging.refresh();
    }else if(window.KlarnaOnsiteService?.push){
      window.KlarnaOnsiteService.push({eventName:'refresh-placements'});
    }
  }
}
function vacLocalizeKlaviyoClose(){
  const closeText=document.getElementById('vac-app-i18n')?.dataset.closeDialog;
  if(!closeText)return;
  document.querySelectorAll('button.klaviyo-close-form').forEach(button=>{
    ['aria-label','title'].forEach(attribute=>{
      if(button.getAttribute(attribute)!==closeText)button.setAttribute(attribute,closeText);
    });
    button.querySelectorAll('svg title').forEach(title=>{
      if(title.textContent!==closeText)title.textContent=closeText;
    });
  });
}
let vacPending=false;
new MutationObserver(records=>{
  const relevant=records.some(r=>
    r.addedNodes.length||
    r.type==='characterData'||
    (r.type==='attributes'&&['title','aria-label','data-locale'].includes(r.attributeName))
  );
  if(vacPending||!relevant)return;
  vacPending=true;
  requestAnimationFrame(()=>{
    vacPending=false;
    vacInitialize();
    vacLocalizeKlaviyoClose();
    vacKlarnaLocaleFallback();
  });
}).observe(document.body,{
  subtree:true,
  childList:true,
  attributes:true,
  characterData:true,
  attributeFilter:['title','aria-label','data-locale']
});
document.addEventListener('pointerover',vacLocalizeKlaviyoClose,true);
document.addEventListener('focusin',vacLocalizeKlaviyoClose,true);
vacInitialize();
vacLocalizeKlaviyoClose();
vacKlarnaLocaleFallback();
window.setTimeout(vacLocalizeKlaviyoClose,250);
window.setTimeout(vacLocalizeKlaviyoClose,1000);
window.setTimeout(vacKlarnaLocaleFallback,250);
window.setTimeout(vacKlarnaLocaleFallback,1000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vac-language-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('vac-language-switcher__form')) return;

    const language = form.querySelector('input[name="language_code"]')?.value;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (!language || !returnTo) return;

    const alternate = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]')).find(
      (link) => link.hreflang.toLowerCase() === language.toLowerCase()
    );
    if (!alternate) return;

    // Use Shopify's translated path and keep the current preview/store domain.
    // The explicit destination also works when /localization keeps return_to unchanged.
    const destination = new URL(alternate.href, window.location.origin);
    returnTo.value = destination.pathname + window.location.search + window.location.hash;
  });
  } catch(e) { console.error(e); }
})();

})();
